module.exports = __webpack_public_path__ + "assets/img/20_969_big.00d1667c.jpg";